import React, { useEffect, useState } from "react";
import UtilsUrl from "../../../utils/UtilsUrl";

const FactureTable = ({ date, data, statusFacture }) => {
  const [image, setImage] = useState(null);
  const [selectedItems, setSelectedItems] = useState([]);

  useEffect(() => {
    // Initialize all items as selected
    if (Array.isArray(data?.success?.factures)) {
      setSelectedItems(data.success.factures.map(() => true));
    }
  }, [data]);

  useEffect(() => {
    const intervalId = setInterval(() => {
      if (!image) {
        const fileUrl = localStorage.getItem("fileUrl");
        if (fileUrl) {
          setImage(fileUrl);
          clearInterval(intervalId);
        }
      }
    }, 100);

    return () => clearInterval(intervalId);
  }, [image]);

  function formatDateToReadable(dateString) {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");

    return `${day}-${month}-${year}`;
  }

  const handleCheckboxChange = (index) => {
    const updatedSelection = [...selectedItems];
    updatedSelection[index] = !updatedSelection[index];
    setSelectedItems(updatedSelection);
  };

  const handlePrint = () => {
    const divToPrint = document.getElementById("factures-vente");
    if (!divToPrint) {
      console.error("Element with id 'factures-vente' not found.");
      return;
    }

    // Filter items that are selected
    const selectedFactures = data?.success?.factures?.filter(
      (_, index) => selectedItems[index]
    );

    const printableContent = `
<html>
    <head>
        <title>État des factures de vente</title>
        <style>
            body {
                font-family: Arial, sans-serif;
                padding: 10px;
            }
            h3 {
                text-align: center;
                margin-bottom: 5px;
            }
            table {
                width: 100%;
                border-collapse: collapse;
                margin-top: 5px;
                text-align: left;
            }
            th, td {
                border: 1px solid black;
                padding: 5px;
            }
            #date{
                width:100px;
            }

           
        </style>
    </head>
    <body>
        <h3>
            État des factures de vente ${
              statusFacture === "1" ? "Payée" : "Non Payée"
            }
        </h3>
        <table>
            <thead>
                <tr>
                    <th id="date">Date</th>
                    <th>Libellé société</th>
                    <th>R.facture</th>
                    <th>M.TTC</th>
                    <th>R.BC</th>
                    <th>B.Reception</th>
                </tr>
            </thead>
            <tbody>
                ${
                  selectedFactures
                    ?.map(
                      (item) => `
                    <tr>
                        <td id="date">${formatDateToReadable(
                          item.creation_date
                        )}</td>
                        <td>${item.titleClient || "-"}</td>
                        <td>${item.refFacture || "-"}</td>
                        <td>${item.montantTtc || "0.00"}</td>
                        <td>${item.refBdc || "-"}</td>
                        <td>${item.refReceptionBdc || "-"}</td>
                    </tr>
                `
                    )
                    .join("") || ""
                }
                <tr>
                    <td colspan="3" style="font-weight: bold;">Total</td>
                    <td colspan="3">${totalPrice?.toFixed(3) || "0.000"}</td>
                </tr>
            </tbody>
        </table>
    </body>
</html>`;

    const newWin = window.open("", "PrintWindow", "width=800,height=600");
    newWin.document.write(printableContent);
    setTimeout(() => {
      newWin.print();
      newWin.close();
    }, 1000);
  };

  const totalPrice = Array.isArray(data?.success?.factures)
    ? data.success.factures.reduce(
        (sum, item, index) =>
          sum + (selectedItems[index] ? parseFloat(item.montantTtc) || 0 : 0),
        0
      )
    : 0;

  return (
    <div style={{ padding: "20px", fontFamily: "Arial, sans-serif" }}>
      <div id="factures-vente">
        {/* Header Section */}
        <h3 style={{ textAlign: "center", marginBottom: "10px" }}>
          État des factures de vente{" "}
          {statusFacture === "1" ? "Payée" : "Non Payée"} de :{" "}
          {data?.success?.client?.libelle}
        </h3>
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            marginTop: "20px",
            textAlign: "left",
          }}
        >
          <thead>
            <tr>
              <th style={{ border: "1px solid black", padding: "10px" }}>
                Select
              </th>
              <th style={{ border: "1px solid black", padding: "10px" }}>
                Date
              </th>
              <th style={{ border: "1px solid black", padding: "10px" }}>
                Libellé société
              </th>
              <th style={{ border: "1px solid black", padding: "10px" }}>
                Référence facture
              </th>
              <th style={{ border: "1px solid black", padding: "10px" }}>
                Montant TTC
              </th>
              <th style={{ border: "1px solid black", padding: "10px" }}>
                Référence bon de commande
              </th>
              <th style={{ border: "1px solid black", padding: "10px" }}>
                Bon de réception
              </th>
            </tr>
          </thead>
          <tbody>
            {Array.isArray(data?.success?.factures) &&
              data.success.factures.map((item, index) => (
                <tr key={index}>
                  <td
                    style={{
                      border: "1px solid black",
                      padding: "10px",
                      textAlign: "center",
                    }}
                  >
                    <input
                      type="checkbox"
                      checked={selectedItems[index]}
                      onChange={() => handleCheckboxChange(index)}
                    />
                  </td>
                  <td style={{ border: "1px solid black", padding: "10px" }}>
                    {formatDateToReadable(item.creation_date)}
                  </td>
                  <td style={{ border: "1px solid black", padding: "10px" }}>
                    {item.titleClient}
                  </td>
                  <td style={{ border: "1px solid black", padding: "10px" }}>
                    {item.refFacture}
                  </td>
                  <td style={{ border: "1px solid black", padding: "10px" }}>
                    {item.montantTtc}
                  </td>
                  <td style={{ border: "1px solid black", padding: "10px" }}>
                    {item.refBdc}
                  </td>
                  <td
                    style={{
                      border: "1px solid black",
                      padding: "10px",
                      textAlign: "center",
                    }}
                  >
                    {item.refReceptionBdc || "-"}
                  </td>
                </tr>
              ))}
            <tr>
              <td
                colSpan="3"
                style={{
                  border: "1px solid black",
                  padding: "10px",
                  fontWeight: "bold",
                }}
              >
                Total
              </td>
              <td
                colSpan="4"
                style={{
                  border: "1px solid black",
                  padding: "10px",
                  fontWeight: "bold",
                }}
              >
                {totalPrice.toFixed(3)}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="card-footer">
        <button className="btn btn-dark float-right" onClick={handlePrint}>
          Imprimer
        </button>
      </div>
    </div>
  );
};

export default FactureTable;
